import Util from "../../../Master/Util";
import UtilBrowser from "../../../Master/UtilBrowser";
import {confJson} from "@/app/config/confJson";
import HttpClient, {RequestOptions} from "@/Fwk/HttpClient";

export default class UtilUnity {
    static tag = `[UtilUnity]`;
    static hostUrl = confJson.h5_res_host;//基础热更路径
    static h5_res_ver = confJson.h5_res_ver;//webgl的br版本
    static tagCode = confJson.h5_version_code;
    static isPreload = false;
    static preloadList:any[] = [];
    private static isInit: boolean;

    static Init() {
        if (this.isInit)return;
        this.isInit = true;
        this.preloadList.push(this.getLoaderJsUrl, this.getDataUrl, this.getFrameworkUrl, this.getCoreUrl);
        if (Util.isLog) {
            for (let i = 0; i < this.preloadList.length; i++) {
                if (Util.isLog){
                    console.log(this.tag, `urls  => ${this.preloadList[i]}`);
                }
            }
        }
        // this.InitPreLoad();
    }

    static get isUnityWeb() {
        return Util.isIOS || UtilBrowser.isSafari || Util.isDev;
    }

    static get getPreLoadUrlJson() {
        return this.hostUrl + "res.json";
    }

    //获取WebGL的文件路径
    static get getWebglBrUrl() {
        return this.hostUrl + this.h5_res_ver;
    }

    static get getBuildUrl() {
        return this.getWebglBrUrl + (this.isUnityWeb ? 'build_unityweb' : 'build_br');
    }

    static get webSuffix() {
        return this.isUnityWeb ? 'unityweb' : 'br';
    }

    static get getLoaderJsUrl() {
        return `${this.getBuildUrl}/WebGL.loader.js?${this.tagCode}`;
    }

    static get getDataUrl() {
        return `${this.getBuildUrl}/WebGL.data.${this.webSuffix}?${this.tagCode}`;
    }

    static get getFrameworkUrl() {
        return `${this.getBuildUrl}/WebGL.framework.js.${this.webSuffix}?${this.tagCode}`;
    }

    static get getCoreUrl() {
        return `${this.getBuildUrl}/WebGL.wasm.${this.webSuffix}?${this.tagCode}`;
    }

    static get streamingAssetsUrl() {
        return `${this.getWebglBrUrl}StreamingAssets`;
    }

    static InitPreLoad()
    {
        if (this.isPreload) return;
        this.isPreload = true;
        if (Util.isLog) console.log(this.tag,"PreLoad", "post URL");
        try
        {
            this.CheckoutPreLoad();
        }catch (e) {
        }
    }

    static CheckoutPreLoad()
    {
        if (Util.isLog) console.log(this.tag,"PreLoad", `CheckoutPreLoad preloadList=${this.preloadList.length}`);
        if (this.preloadList.length <= 0) return;
        const url = this.preloadList[0];
        this.PreLoadUrl(url,()=>{
            this.CheckoutPreLoad();
        });
        this.preloadList.shift();//删除第一个数组
    }

    static PreLoadUrl(url:any, action:any)
    {
        if (Util.isLog) console.log(this.tag,"PreLoad", `PreLoadUrl url=${url}`);

        HttpClient.FAjax({types: 'GET', url: url, data: null} as RequestOptions, (response) => {
            if (Util.isLog) {
                // console.log(this.tag, `PreLoadUrl ==>> Track success`);
                console.log(this.tag,'get url OK',response)
            }
            action();
        });


    }


}
